import { render, staticRenderFns } from "./VueMultiselect.vue?vue&type=template&id=0cc58bf2&"
import script from "./VueMultiselect.vue?vue&type=script&lang=js&"
export * from "./VueMultiselect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports